export const CARD_LIST_TOGGLE = 'state.actions.card-list.CARD_LIST_TOGGLE' as const;

export type CardListToggleAction = {
	type: typeof CARD_LIST_TOGGLE;
	payload: {
		cardListId: string;
	};
};

export const cardListToggle = (cardListId: string): CardListToggleAction => ({
	type: CARD_LIST_TOGGLE,
	payload: {
		cardListId,
	},
});

export const SET_COLLAPSED_CARD_LIST = 'state.actions.card-list.SET_COLLAPSED_CARD_LIST' as const;

export type SetCollapsedCardListAction = {
	type: typeof SET_COLLAPSED_CARD_LIST;
	payload: {
		cardListIds: string[];
	};
};

export const setCollapsedCardLists = (cardListIds: string[]): SetCollapsedCardListAction => ({
	type: SET_COLLAPSED_CARD_LIST,
	payload: {
		cardListIds,
	},
});

export const CARD_LISTS_DISABLE = 'state.actions.card-list.CARD_LISTS_DISABLE' as const;

export type CardListsDisableAction = {
	type: typeof CARD_LISTS_DISABLE;
	payload: {
		cardListIds: string[];
	};
};

export const cardListsDisable = (cardListIds: string[]): CardListsDisableAction => ({
	type: CARD_LISTS_DISABLE,
	payload: {
		cardListIds,
	},
});

export const CARD_LISTS_ENABLE_ALL = 'state.actions.card-list.CARD_LISTS_ENABLE_ALL' as const;

export type CardListsEnableAllAction = {
	type: typeof CARD_LISTS_ENABLE_ALL;
};

export const cardListsEnableAll = (): CardListsEnableAllAction => ({
	type: CARD_LISTS_ENABLE_ALL,
});

export const CARD_LIST_DRAG_START = 'state.actions.card-list.DRAG_START' as const;

export type CardListDragStartAction = {
	type: typeof CARD_LIST_DRAG_START;
	payload: {
		cardListIds: string[];
		sourceCardListId: string | undefined;
		sourceCardGroupId: string | undefined;
	};
};

export const cardListDragStart = (
	cardListIds: string[],
	sourceCardListId: string | undefined,
	sourceCardGroupId: string | undefined,
): CardListDragStartAction => ({
	type: CARD_LIST_DRAG_START,
	payload: {
		cardListIds,
		sourceCardListId,
		sourceCardGroupId,
	},
});

export const CARD_LIST_DRAG_END = 'state.actions.card-list.DRAG_END' as const;

export type CardListDragEndAction = {
	type: typeof CARD_LIST_DRAG_END;
};

export const cardListDragEnd = (): CardListDragEndAction => ({
	type: CARD_LIST_DRAG_END,
});

export const CARD_GROUP_TOGGLE = 'state.actions.card-list.CARD_GROUP_TOGGLE' as const;

export type CardGroupToggleAction = {
	type: typeof CARD_GROUP_TOGGLE;
	payload: {
		parentId: number;
	};
};

export const cardGroupToggle = (parentId: number): CardGroupToggleAction => ({
	type: CARD_GROUP_TOGGLE,
	payload: {
		parentId,
	},
});

export const SET_COLLAPSED_CARD_GROUP = 'state.actions.card-list.SET_COLLAPSED_CARD_GROUP' as const;

export const SET_EXPANDED_CARD_GROUP = 'state.actions.card-list.SET_EXPANDED_CARD_GROUP' as const;

export type SetCollapsedCardGroupAction = {
	type: typeof SET_COLLAPSED_CARD_GROUP;
	payload: {
		parentIds: string[];
	};
};

export type SetExpandedCardGroupAction = {
	type: typeof SET_EXPANDED_CARD_GROUP;
	payload: {
		parentIds: string[];
	};
};

export const setCollapsedCardGroups = (parentIds: string[]): SetCollapsedCardGroupAction => ({
	type: SET_COLLAPSED_CARD_GROUP,
	payload: {
		parentIds,
	},
});

export const setExpandedCardGroups = (parentIds: string[]): SetExpandedCardGroupAction => ({
	type: SET_EXPANDED_CARD_GROUP,
	payload: {
		parentIds,
	},
});

export const CLEAR_COLLAPSED_CARD_GROUP =
	'state.actions.card-list.CLEAR_COLLAPSED_CARD_GROUP' as const;

export const CLEAR_EXPANDED_CARD_GROUP =
	'state.actions.card-list.CLEAR_EXPANDED_CARD_GROUP' as const;

export type ClearCollapsedCardGroupAction = {
	type: typeof CLEAR_COLLAPSED_CARD_GROUP;
	payload: {
		parentId: number;
	};
};

export type ClearExpandedCardGroupAction = {
	type: typeof CLEAR_EXPANDED_CARD_GROUP;
	payload: {
		parentId: number;
	};
};

export const clearCollapsedCardGroup = (parentId: number): ClearCollapsedCardGroupAction => ({
	type: CLEAR_COLLAPSED_CARD_GROUP,
	payload: {
		parentId,
	},
});

export const clearExpandedCardGroup = (parentId: number): ClearExpandedCardGroupAction => ({
	type: CLEAR_EXPANDED_CARD_GROUP,
	payload: {
		parentId,
	},
});

export const COLLAPSE_ALL_CARD_GROUPS = 'state.actions.card-list.COLLAPSE_ALL_CARD_GROUPS' as const;

export type CollapseAllCardGroupsAction = {
	type: typeof COLLAPSE_ALL_CARD_GROUPS;
};

export const collapseAllCardGroups = (): CollapseAllCardGroupsAction => ({
	type: COLLAPSE_ALL_CARD_GROUPS,
});

export type Action =
	| CardListToggleAction
	| CardListsDisableAction
	| CardListsEnableAllAction
	| SetCollapsedCardListAction
	| CardListDragStartAction
	| CardListDragEndAction
	| CardGroupToggleAction
	| SetCollapsedCardGroupAction
	| ClearCollapsedCardGroupAction
	| SetExpandedCardGroupAction
	| ClearExpandedCardGroupAction
	| CollapseAllCardGroupsAction;
